import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchUserPermissions } from "model/UserInfoModel";
import { registerPermissionLoader } from "libs/context/permissionBridge";

const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [initialized, setInitialized] = useState(false);
  const [permissionData, setPermissionData] = useState();

  const fetchPermissionData = useCallback(async () => {
    const authUser = localStorage.getItem("authUser");
    if (!authUser) {
      setPermissionData(undefined);
      setInitialized(true);
      return;
    }

    setLoading(true);
    try {
      const response = await fetchUserPermissions();
      if (response?.success) {
        setPermissionData(response?.data?.userTypePermissions);
        localStorage.setItem("userData", JSON.stringify(response?.data?.user));
      }
    } catch (err) {
      setError(err);
      toast.error(err?.message || "Failed to load user permissions");
    } finally {
      setLoading(false);
      setInitialized(true);
    }
  }, []);

  useEffect(() => {
    registerPermissionLoader(fetchPermissionData);
    fetchPermissionData();

    return () => registerPermissionLoader(null);
  }, [fetchPermissionData]);

  return (
    <PermissionContext.Provider
      value={{ fetchPermissionData, permissionData, loading, error, initialized }}
    >
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissionContext = () => useContext(PermissionContext);
